// src/pages/News/NewsDetailsModal.jsx
import React from "react";
import { FaTimes, FaClock } from "react-icons/fa";

const NewsDetailsModal = ({ isOpen, onClose, news }) => {
  if (!isOpen || !news) return null;

  const imageUrl = news.image_url || "/img/default_image.jpg";

  const createdLabel = news.created_at
    ? new Date(news.created_at).toLocaleDateString("fr-FR", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : "";

  const destinataires = news.destinataires_news || "Tout public";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm">
      <div className="relative w-full max-w-5xl max-h-[90vh] overflow-y-auto rounded-2xl bg-white dark:bg-slate-900 shadow-2xl">
        {/* Bouton fermer */}
        <button
          type="button"
          onClick={onClose}
          className="absolute top-4 right-4 inline-flex items-center justify-center w-9 h-9 rounded-full bg-black/70 text-white hover:bg-black transition z-10"
          aria-label="Fermer"
        >
          <FaTimes />
        </button>

        {/* Haut : image */}
        <div className="relative h-64 md:h-80 w-full overflow-hidden rounded-t-2xl">
          <img
            src={imageUrl}
            alt={news.title}
            className="h-full w-full object-cover"
          />
          {!news.is_active && (
            <span className="absolute top-4 left-4 rounded-full bg-gray-600/90 text-white text-[10px] font-semibold px-3 py-1 uppercase tracking-[0.18em] shadow">
              Archivée
            </span>
          )}
          {destinataires && (
            <span className="absolute bottom-4 left-4 rounded-full bg-black/70 backdrop-blur text-white text-[10px] font-semibold px-3 py-1 uppercase tracking-[0.16em]">
              {destinataires}
            </span>
          )}
        </div>

        {/* Contenu */}
        <div className="p-5 md:p-7 space-y-4">
          <header className="space-y-2">
            <p className="text-[11px] uppercase tracking-[0.32em] text-primary font-semibold">
              Actualité du Comité
            </p>
            <h2 className="text-2xl md:text-3xl font-extrabold text-slate-900 dark:text-white font-montserrat">
              {news.title}
            </h2>

            <div className="flex flex-wrap items-center gap-3 text-xs text-slate-500 dark:text-slate-300">
              <span className="inline-flex items-center gap-1">
                <FaClock className="text-[11px]" />
                <span>Publié le {createdLabel}</span>
              </span>
              {news.author && (
                <span className="inline-flex items-center rounded-full bg-slate-100 dark:bg-slate-800 px-2.5 py-1 text-[11px] font-semibold">
                  Par {news.author.prenom} {news.author.nom}
                </span>
              )}
            </div>
          </header>

          <hr className="border-slate-200 dark:border-slate-700" />

          <article className="prose prose-sm md:prose-base max-w-none text-slate-700 dark:text-slate-100 dark:prose-invert bg-gray-50 dark:bg-slate-800 p-4 rounded-lg">
            <div
              // on souhaite garder les liens cliquables ici
              dangerouslySetInnerHTML={{ __html: news.content }}
            />
          </article>
        </div>
      </div>
    </div>
  );
};

export default NewsDetailsModal;
